import { usePageRedirectToOrgSlug } from "@/lib/use-page-redirect-to-org-slug";

const AccountRedirectPage = () => {
  // Account page redirects to account page with org slug
  // /account -> /[orgSlug]/account
  usePageRedirectToOrgSlug();
};

export default AccountRedirectPage;
